import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {styled} from 'styled-components'

export const StyledSchoolSwitchStepsWrapper = styled(Flexbox)`
    & label {
        width: 128px;
    }
`
